import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import PricingHeroSection from './components/PricingHeroSection';
import PricingTiersSection from './components/PricingTiersSection';
import PricingCalculatorSection from './components/PricingCalculatorSection';
import ROIProjectionSection from './components/ROIProjectionSection';
import FinancingOptionsSection from './components/FinancingOptionsSection';
import ComparisonSection from './components/ComparisonSection';
import PricingTestimonialsSection from './components/PricingTestimonialsSection';
import PricingContactSection from './components/PricingContactSection';

const PricingPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleCalculatorScroll = () => {
    const calculatorSection = document.getElementById('pricing-calculator');
    if (calculatorSection) {
      const headerHeight = 80;
      const targetPosition = calculatorSection.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleContactScroll = () => {
    const contactSection = document.getElementById('pricing-contact');
    if (contactSection) {
      const headerHeight = 80;
      const targetPosition = contactSection.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <PricingHeroSection 
          onCalculatorScroll={handleCalculatorScroll}
          onContactScroll={handleContactScroll}
        />
        
        <PricingTiersSection />
        
        <PricingCalculatorSection />
        
        <ROIProjectionSection />
        
        <FinancingOptionsSection />
        
        <ComparisonSection />
        
        <PricingTestimonialsSection />
        
        <PricingContactSection />
      </main>

      {/* Footer */}
      <footer className="bg-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-10 h-10 bg-white rounded-lg">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 21L12 2L21 21H3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="var(--color-primary)"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold">AlumERP</h3>
                  <p className="text-sm opacity-80">
                    {currentLanguage === 'en' ? 'Aluminum Extrusion ERP' : 'एल्यूमीनियम एक्सट्रूज़न ERP'}
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-80 leading-relaxed mb-6">
                {currentLanguage === 'en' ? 'Transparent pricing with no hidden costs. Choose the right plan for your manufacturing scale and grow with confidence.' : 'कोई छुपी हुई लागत के साथ पारदर्शी मूल्य निर्धारण। अपने विनिर्माण स्केल के लिए सही योजना चुनें और विश्वास के साथ बढ़ें।'}
              </p>
              <div className="flex space-x-4">
                <div className="text-center">
                  <div className="text-2xl font-bold">₹0</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Setup Fee' : 'सेटअप शुल्क'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">30</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Days Trial' : 'दिन ट्रायल'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">24/7</div>
                  <div className="text-xs opacity-80">
                    {currentLanguage === 'en' ? 'Support' : 'सहायता'}
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Info */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Pricing Plans' : 'मूल्य योजनाएं'}
              </h4>
              <ul className="space-y-2 text-sm opacity-80">
                <li><a href="#pricing-tiers" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Starter Plan' : 'स्टार्टर योजना'}
                </a></li>
                <li><a href="#pricing-tiers" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Professional Plan' : 'प्रोफेशनल योजना'}
                </a></li>
                <li><a href="#pricing-tiers" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Enterprise Plan' : 'एंटरप्राइज़ योजना'}
                </a></li>
                <li><a href="#pricing-calculator" className="hover:opacity-100 transition-opacity">
                  {currentLanguage === 'en' ? 'Custom Quote' : 'कस्टम कोट'}
                </a></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Need Help?' : 'सहायता चाहिए?'}
              </h4>
              <div className="space-y-2 text-sm opacity-80">
                <p>
                  {currentLanguage === 'en' ? 'Email: pricing@alumerp.com' : 'ईमेल: pricing@alumerp.com'}
                </p>
                <p>
                  {currentLanguage === 'en' ? 'Phone: +91 9876543210' : 'फोन: +91 9876543210'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage;